import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

interface DepositSlipRow {
  idIncasso: string;
  apriDettaglio?: () => void;
}

@Component({
  selector: 'rev-receipts-deposit-slip-action-cell',
  imports: [MatButtonModule],
  template: `
    <button
      matButton="outlined"
      type="button"
      [attr.aria-label]="'Apri distinta incasso ' + itemData.idIncasso"
      [disabled]="!itemData.apriDettaglio"
      (click)="apri($event)"
    >
      Distinta
    </button>
  `,
  styles: `
    :host {
      display: flex;
      justify-content: center;
    }
  `,
})
export class receiptsDepositSlipActionCell {
  @Input({ required: true }) itemData!: DepositSlipRow;
  @Input() infoColumn: unknown;
  @Input() _reloadData?: { emit: () => void };

  apri(event: MouseEvent): void {
    event.stopPropagation();
    this.itemData.apriDettaglio?.();
  }
}
